import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

interface ToolCardProps {
    title: string;
    summary: string;
    imgSrc: string;
    link: string;
    free: string;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, summary, imgSrc, link, free }) => {
    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <Link legacyBehavior href={link}>
                <a>
                    <div className="relative h-48 w-full">
                        <Image src={imgSrc} alt={title} layout="fill" objectFit="cover" />
                    </div>
                </a>
            </Link>
            <div className="p-4">
                <h2 className="text-xl font-semibold">
                    <Link legacyBehavior href={link}>
                        <a>{title}</a>
                    </Link>
                    <small className='bg-slate-100 p-1 ml-2 text-xs'>{free}</small>
                </h2>
                <p className="text-gray-600 mt-2">
                    <Link legacyBehavior href={link}>
                        <a>{summary}</a>
                    </Link>
                </p>
                <Link legacyBehavior href={link}>
                    <a className="text-blue-500 mt-4 inline-block hover:underline">Learn More</a>
                </Link>
            </div>
        </div>
    );
};

export default ToolCard;